<template>
  <div>
    <v-dialog
      persistent
      v-model="dialog"
      max-width="70%"
      content-class="dialog-top"
    >
      <v-card class="pa-4">
        <div v-if="loadingTickets" class="loading-container">
          <v-container fluid>
            <v-layout column align-center justify-center>
              <v-progress-circular
                indeterminate
                color="primary"
                size="64"
                width="6"
              ></v-progress-circular>
              <p class="mt-4 text-subtitle-1 grey--text text--darken-1">
                Loading Tickets From {{ selectedManageengineUser.name }}...
              </p>
            </v-layout>
          </v-container>
        </div>

        <dx-grid
          :beforeSetupGrid="beforeSetupGrid"
          v-show="!loadingTickets"
          :url="url"
          :columns="columns"
          :title="title"
          ref="grid"
          navigationPath="HelpDeskTechnicianRequestView"
          navigationField="displayID"
          :selectionEnabled="false"
          :hideActions="true"
          :disableExporting="true"
          :pageSize="10"
          :disableStoring="true"
          :onLoaded="onLoadedUserTickets"
          :onRowClicked="onRowClicked"
          name="UserTicketsDialog"
        ></dx-grid>

        <v-card-actions class="mr-0 mt-3 ml-0 pb-0">
          <v-spacer></v-spacer>

          <v-btn color="default" dark @click="closeDialog">Close</v-btn>
          <v-btn
            :disabled="!selectedManageengineUser"
            :dark="selectedManageengineUser != null"
            color="success"
            @click="openNewTicket"
            >Create Ticket For {{ selectedManageengineUser.name }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CreateTicketByTech
      v-model="newTicketDialog"
      :initial-data="{ requester: selectedManageengineUser }"
      @newTicketSended="
        () => {
          clearSearch(), closeDialog();
        }
      "
    />
  </div>
</template>

<script>
import CreateTicketByTech from "./CreateTicketByTech.vue";
export default {
  components: {
    CreateTicketByTech,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },

  created() {
    if (this.initialData.manageengineUser) {
      this.selectedManageengineUser = this.initialData.manageengineUser;
      this.dialog = true;
    }
  },

  data: () => ({
    loadingTickets: true,
    title: `Tickets`,
    url: "",
    dialog: false,
    processing: false,
    selectedManageengineUser: null,
    selectedManageengineUserList: [],
    newTicketDialog: false,
    displayIdsList: [],
    columns: [
      {
        label: "Priority",
        field: "priorityName",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          return "mdi-box-shadow";
        },
        iconColor: (value) => {
          switch (value) {
            case "1 High":
            case "3 Option 8":
              return "#e74c3c";
            case "2 Normal":
              return "#f39c12";
            case "4 Low":
              return "#7f8c8d";
            default:
              return "#bdc3c7";
          }
        },
      },
      {
        label: "Status",
        field: "statusIcon",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Ticket #",
        field: "displayID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        link: "HelpDeskTechnicianRequestView",
        template: "link-cell-template",
        openInNewTab: true,
      },
      //   {
      //     label: "Name",
      //     field: "requesterName",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      //   },
      {
        label: "Subject",
        field: "subject",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Technician",
        field: "technicianName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Created At",
        field: "createdAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Due By",
        field: "dueByAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "ETA",
        field: "dueByTimeValue",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "text-color-cell-template",
      },
      {
        label: "Last Updated At",
        field: "lastUpdatedAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),

  methods: {
    async beforeSetupGrid() {
      await this.getManageengineUserInfo(this.selectedManageengineUser.id);

      this.columns.find((c) => c.field == "dueByTimeValue").getTextColor = (
        value
      ) => {
        if (!value) return;
        if (value.startsWith("In")) {
          return "blue";
        } else {
          return "red";
        }
      };

      this.title = `Tickets of ${this.selectedManageengineUser.name}`;

      const userIds = [];
      this.selectedManageengineUserList.forEach((user) => {
        userIds.push(user.id);
      });
      if (userIds.length < 1) return;
      this.url = `Manageengine?statuses=&technicians&filterForUserId=${userIds}&filterTicketsNeedingAttention=false`;
    },

    async getManageengineUserInfo(id) {
      try {
        const response = await this.$http.get(
          `api/manageengineUSers/getManageengineUserInfo?id=${id}`
        );
        this.selectedManageengineUserList = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    clearSearch() {
      this.$emit("clearSearch");
    },

    closeDialog() {
      this.$emit("closed");
      this.dialog = false;
      this.selectedManageengineUser = this.initialData.manageengineUser;
    },

    openNewTicket() {
      if (!this.selectedManageengineUser) {
        return this.$notify({
          text: "select other user",
          group: "notification",
          type: "error",
        });
      }

      this.newTicketDialog = true;
    },

    reloadGrid() {
      this.$refs.grid.reloadDataSource(this.url);
    },
    onLoadedUserTickets(v) {
      this.loadingTickets = false;
      this.mapResults(v);
    },

    mapResults(results) {
      results.map((t) => {
        t.technicianName =
          t.technicianName == "UserPortal" ? "" : t.technicianName;
        if (t.statusName != "Closed") {
          t.dueByTimeValue = this.getDueBy(t.dueByTimeValue);
        } else {
          t.dueByTimeValue = null;
        }
        return t;
      });
    },

    getDueBy(dueByTimeValue) {
      if (!dueByTimeValue) return null;
      const currentTime = new Date().getTime();

      const distance = dueByTimeValue - currentTime;

      const absDistance = Math.abs(distance);
      const days = Math.floor(absDistance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (absDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (absDistance % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((absDistance % (1000 * 60)) / 1000);

      const timeStr = `${days ? days + " days" : ""} ${
        hours ? hours + " hours" : ""
      }  ${minutes} minutes`;

      if (distance >= 0) {
        return `In ${timeStr}`;
      } else {
        return `Delay by ${timeStr}`;
      }
    },

    async loadDisplayIdsList() {
      this.displayIdsList = [];
      const data = this.$refs.grid.grid.getDataSource().items();
      data.forEach((row) => {
        this.displayIdsList.push(row.displayID);
      });
    },

    async onRowClicked(row) {
      await this.loadDisplayIdsList();
      this.$router.push({
        name: "HelpDeskTechnicianRequestView",
        params: { id: row.displayID },
        query: this.displayIdsList,
      });
      this.closeDialog();
    },
  },
};
</script>

<style>
.dialog-top {
  align-self: flex-start;
  margin-top: 50px;
}

.loading-container {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
